var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,10.945c-12.15,0-22,13.055-22,13.055,0,0,9.85,13.055,22,13.055s22-13.055,22-13.055c0,0-9.85-13.055-22-13.055ZM24,33.523c-5.259,0-9.523-4.264-9.523-9.523s4.264-9.523,9.523-9.523,9.523,4.264,9.523,9.523-4.264,9.523-9.523,9.523Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.439,23.731c-1.751,0-3.17-1.419-3.17-3.17,0-1.251.726-2.33,1.779-2.845-.645-.21-1.333-.325-2.048-.325-3.65,0-6.609,2.959-6.609,6.609s2.959,6.609,6.609,6.609,6.609-2.959,6.609-6.609c0-.715-.115-1.403-.325-2.048-.516,1.052-1.594,1.779-2.845,1.779Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconView);
export default __webpack_public_path__ + "static/media/icon-view.6f27a3226497b0523568beffaa9d56c0.svg";
export { ForwardRef as ReactComponent };